import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from "echarts-for-react";


class BarChartTalents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dimensionValueList: [],

    }
  }
  componentDidMount() {

  }


  render() {

    let { handleStrength, list } = this.props;
    let ParaNameList = []

    let insertData = []
    function barWidthPerc(value) {
      let valuePerc = Number(value) * 0.10
      // console.log("value----->", value)
      // console.log("valuePerc----->", valuePerc)
      return valuePerc
    }

    if (list && list.length > 0) {
      list.forEach((ele) => {
        ParaNameList.push(ele.dimension)
        insertData.push({
          value: barWidthPerc(ele.count),
          itemStyle: {
            color: ele.colorCode
          }
        })
      })
    }

    function getValue(dimension) {
      let temp = {
        "rank": "",
        "count": 0,
        "color": '#757575'
      }
      if (list && list.length > 0) {
        let index = list.findIndex(prev => prev.dimension === dimension);
        if (index !== -1) {
          temp["count"] = list[index]["count"];
          temp["color"] = list[index]["colorCode"];
        }
      }
      return temp
    }

    function getPerc(count, list) {
      let max = 0;
      if (list && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          let ele_count = getValue(list[i])["count"];
          if (ele_count > max) {
            max = ele_count;
          }
        }
      }
      let value = max > 0 ? (count * 100) / max : 0;
      console.log("value---->", value)
      console.log("max---->", max)
      return value ? value.toFixed(2) : 0
    }

    return (
      <>

        <div className="px-6 pb-6">




          <div className="pb-6 px-6 relative">
            <table className="w-full">
              <tbody className="divide-y-4 divide-white">
                {ParaNameList && ParaNameList.length > 0 ? (
                  [...ParaNameList]
                    .sort((a, b) => getValue(b).count - getValue(a).count) // ✅ Sort descending
                    .map((label, index) => {
                      const { count, color } = getValue(label);
                      return (
                        <tr key={index} className="border-b text-[#212121] text-sm border-l border-r border-white py-4">
                          {/* Label */}
                          <td className="w-[18%] text-sm text-right border-r-2 border-white pr-4">
                            {label}
                          </td>

                          {/* Bar */}
                          <td className="flex items-center border-r-2 border-white relative">
                            <div className="flex h-7 w-full bg-[#212121]/10 overflow-hidden">
                              <div className="h-7" style={{ backgroundColor: color, width: `${getPerc(count, ParaNameList)}%`, }}></div>
                            </div>
                            <span className="w-[12%] text-sm px-2 py-1">{count}</span>
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center text-sm py-4 text-[#757575] font-semibold">
                      Data not found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>



            {/* Tooltip near cursor */}
            {/* {tooltip.visible && (
              <div
                className="fixed z-50 bg-[#333] text-white text-base rounded px-2 py-1 whitespace-nowrap"
                style={{
                  top: tooltip.y,
                  left: tooltip.x,
                  pointerEvents: "none",
                }}
              >
                {tooltip.label}: {tooltip.value}%
              </div>
            )} */}
          </div>







          {ParaNameList && ParaNameList.length > 0 && false ?
            <ReactEcharts
              onEvents={{
                'click': (params) => handleStrength(params)
              }}
              style={{
                marginTop: '-40px',
                height: '800px'
              }}
              option={{
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  },
                  formatter: function (a) {
                    let dimension = a && a[0] && a[0]["axisValue"] ? a[0]["axisValue"] : "";
                    let html = `<b>${dimension}</b> <span style=\"display:inline-block;margin-left:4px;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${getValue(dimension).color};\"></span>`
                    html += `<p><b>Frequency: </b> ${getValue(dimension).count}</p>`
                    return html
                  }
                },

                legend: {
                  data: []
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'value',
                  splitLine: {
                    lineStyle: {
                      color: '#ffffff'
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ffffff'
                    }
                  },

                },
                yAxis: {
                  type: 'category',
                  data: ParaNameList,
                  axisLine: {
                    lineStyle: {
                      color: '#ffffff'
                    }
                  },
                  axisLabel: {
                    color: "#000",
                    fontStyle: 'bold'
                  },
                },
                series: [
                  {
                    name: 'Score',
                    type: 'bar',
                    barWidth: '25px',
                    barCategoryGap: '5px',
                    stack: '总量',
                    label: {
                      show: true,
                      position: 'right',
                      formatter: function (value) {
                        return (getValue(value.name ? value.name : "").count).toString()
                      }
                    },
                    data: insertData

                  },

                ]
              }}
            />
            : null}

        </div>

      </>
    );
  }
}
function mapStateToProps(state) {
  // //////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(BarChartTalents);
